import React, { useState, Fragment, useEffect } from 'react';

// Utils
import classnames from 'classnames';

import { Type, Box } from '@nerdwallet/currency';
import { Tracking } from '@nerdwallet/nw-client-lib';
// React Components
import Icon from '@nerdwallet/react-icon';

// CSS
import styles from './control-panel.module.less';

// Constants
const { formOpen, formCancel } = Tracking;
const FORM_NAME = 'controlPanel';

interface ControlPanelProps {
  panelContent: React.ReactNode;
  openHandleText?: string;
  closeText?: string;
  enableTracking?: boolean;
}

/**
 * Control Panel for the calculators
 * @param param
 * @returns
 */
export const ControlPanel: React.FC<ControlPanelProps> = ({
  panelContent,
  openHandleText,
  enableTracking,
  closeText,
}) => {
  // state if the control panel is open
  const [isControlPanelOpen, setControlPanelOpen] = useState(false);

  useEffect(() => {
    if (isControlPanelOpen) {
      document?.body?.classList?.add(styles.bodyOverflowHidden);
    } else {
      document?.body?.classList?.remove(styles.bodyOverflowHidden);
    }
  }, [isControlPanelOpen]);

  const handleOpenControlPanel = (e, open: boolean) => {
    e.preventDefault();
    e.stopPropagation();

    if (enableTracking) {
      const trackingFunction = open ? formOpen : formCancel;

      trackingFunction({
        formName: FORM_NAME,
        fieldName: 'controlPanel',
      });
    }
    setControlPanelOpen(open);
  };

  const renderToggleHandles = () => {
    return (
      <Box
        className={styles.controlPanelBack}
        onClick={(e) => {
          handleOpenControlPanel(e, false);
        }}
      >
        <Icon
          font="gizmo"
          icon="left"
          className={styles.controlPanelBackIcon}
        />
        <Type size="2" className={styles.controlPanelBackText}>
          {closeText}
        </Type>
      </Box>
    );
  };

  const classes = classnames(styles.controlPanelWrapper, {
    [styles.controlPanelOpen]: isControlPanelOpen,
  });

  return (
    <Fragment>
      <Box className={classes}>
        <Box className={styles.controlPanel}>
          {renderToggleHandles()}
          {panelContent}
        </Box>
      </Box>
      {!isControlPanelOpen && (
        <Box
          className={styles.editCpHandle}
          onClick={(e) => {
            handleOpenControlPanel(e, true);
          }}
        >
          {openHandleText}
        </Box>
      )}
    </Fragment>
  );
};

ControlPanel.defaultProps = {
  closeText: 'Save & exit',
  enableTracking: false,
  openHandleText: 'Refine Results',
};

export default ControlPanel;
